import { Outlet } from 'react-router-dom';

import { useSessionReplayWindow } from '@/shared/analytics/useSessionReplayWindow';
import { InvoiceQrEngineProvider, useInvoiceQrEngine } from '../hooks/useInvoiceQrEngine';
import { QrMaintenanceGate } from './QrMaintenanceGate';

/**
 * Raíz de las rutas públicas: una sola resolución del motor para la página y el
 * estado de la solicitud, y una ventana de grabación. Aquí un TERCERO, el cliente del negocio, captura sus
 * datos fiscales: el replay enmascara los inputs, y el texto que pinta RFC,
 * nombre o correo lleva `amp-mask`.
 */
const PublicQrShell = () => {
  // Solo la página nueva enmascara lo que pinta; la vieja no se graba.
  const { engine } = useInvoiceQrEngine();
  useSessionReplayWindow('invoice_v2_qr_public', engine === 'go');
  return (
    <QrMaintenanceGate surface='public'>
      <Outlet />
    </QrMaintenanceGate>
  );
};

export const PublicQrLayout = () => (
  <InvoiceQrEngineProvider>
    <PublicQrShell />
  </InvoiceQrEngineProvider>
);
